/* ============================================================
   EDUCARÉ — Google Analytics 4
   Módulo único de eventos. Ningún gtag() suelto en otros archivos:
   todo pasa por window.PSAnalytics.

   Nombres del diccionario de eventos de PS Digitales y los recomendados
   de GA4 donde existen (view_item, add_to_cart, begin_checkout…).
   `purchase` NO se emite desde aquí: ver docs/shopify-pixel-purchase.js.
   ============================================================ */
'use strict';
(function () {
  var CTX = window.GA4_CONTEXT || {};
  var CURRENCY = CTX.currency || 'MXN';
  var CATEGORIA = 'Material didáctico';

  function send(name, params) {
    if (typeof window.gtag !== 'function') return;
    window.gtag('event', name, params || {});
  }

  /* Ubicación del CTA: header · hero · body · footer · floating · popup.
     data-cta-location en el enlace o en un ancestro manda. */
  function ctaLocation(el) {
    var explicit = el.closest('[data-cta-location]');
    if (explicit) return explicit.getAttribute('data-cta-location');
    if (el.closest('.encabezado, .menu-movil')) return 'header';
    if (el.closest('.carrito-lateral')) return 'popup';
    if (el.closest('.pie, footer')) return 'footer';
    if (el.closest('.hero')) return 'hero';
    return 'body';
  }
  function ctaText(el) {
    var t = (el.textContent || '').replace(/\s+/g, ' ').trim();
    if (!t) t = el.getAttribute('aria-label') || '';
    return t.slice(0, 100);
  }
  function pagePath() { return location.pathname + location.search; }

  /* Clics por delegación, en captura para que ningún stopPropagation se los coma. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var link = e.target.closest('a[href]');
    if (!link) return;
    var href = link.getAttribute('href') || '';

    if (href.indexOf('wa.me') !== -1 || href.indexOf('api.whatsapp.com') !== -1) {
      PSAnalytics.whatsappClick(ctaLocation(link), ctaText(link)); return;
    }
    if (href.indexOf('tel:') === 0) { PSAnalytics.contactClick('phone_click', ctaLocation(link), ctaText(link)); return; }
    if (href.indexOf('mailto:') === 0) { PSAnalytics.contactClick('email_click', ctaLocation(link), ctaText(link)); return; }
    if (link.hasAttribute('data-map')) { send('map_click', { cta_location: ctaLocation(link) }); return; }
    if (link.hasAttribute('data-social')) { send('social_click', { network: link.getAttribute('data-social') }); return; }
    if (href.indexOf('/checkout') === 0) { PSAnalytics.beginCheckout(); return; }

    /* «Quitar» de la página /cart: recarga la página, nunca pasa por theme.js. */
    if (link.classList.contains('carrito-tabla__quitar')) {
      PSAnalytics.removeFromCart({
        item_id: link.getAttribute('data-ga-item-id') || '',
        item_name: link.getAttribute('data-ga-item-name') || '',
        item_category: CATEGORIA,
        price: parseFloat(link.getAttribute('data-ga-price')) || 0,
        quantity: parseInt(link.getAttribute('data-ga-qty'), 10) || 1
      });
      return;
    }

    var card = link.closest('.tarjeta[data-ga-item-id]');
    if (card && href.indexOf('/products/') !== -1) {
      send('select_item', {
        item_list_name: CTX.list_name || 'listado',
        items: [{
          item_id: card.getAttribute('data-ga-item-id'),
          item_name: card.getAttribute('data-ga-item-name'),
          item_category: card.getAttribute('data-ga-item-category') || CATEGORIA,
          price: parseFloat(card.getAttribute('data-ga-price')) || 0,
          quantity: 1
        }]
      });
    }
  }, true);

  /* Ordenar la colección: un filtro es select_content. */
  document.addEventListener('change', function (e) {
    if (e.target && e.target.matches('[data-orden]')) {
      send('select_content', { content_type: 'orden', item_id: e.target.value });
    }
  });

  function initScrollDepth() {
    var marks = [25, 50, 75, 90], hit = {}, ticking = false;
    function check() {
      var doc = document.documentElement;
      var scrollable = doc.scrollHeight - window.innerHeight;
      if (scrollable <= 0) return;
      var pct = ((window.scrollY || doc.scrollTop) / scrollable) * 100;
      marks.forEach(function (m) {
        if (pct >= m && !hit[m]) { hit[m] = true; send('scroll_depth', { percent_scrolled: m, page_path: pagePath() }); }
      });
      if (hit[90]) window.removeEventListener('scroll', onScroll);
    }
    function onScroll() { if (ticking) return; ticking = true; requestAnimationFrame(function () { check(); ticking = false; }); }
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function initPageEvents() {
    if (CTX.template === 'product' && CTX.item) {
      send('view_item', { currency: CURRENCY, value: CTX.item.price, items: [CTX.item] });
    }
    if (CTX.template === 'collection' && CTX.list_items && CTX.list_items.length) {
      send('view_item_list', { item_list_name: CTX.list_name, items: CTX.list_items });
    }
    if (CTX.template === 'search' && CTX.search_term) {
      send('search', { search_term: CTX.search_term, search_results: CTX.search_results });
    }
    if (CTX.template === 'cart' && CTX.cart_items && CTX.cart_items.length) {
      send('view_cart', { currency: CURRENCY, value: CTX.cart_value, items: CTX.cart_items });
    }
    /* La 404 es una avería: broken_path dice qué se rompió, referrer_url de quién es la culpa. */
    if (CTX.template === '404') {
      send('page_not_found', {
        broken_path: (location.pathname + location.search).slice(0, 100),
        referrer_url: document.referrer ? document.referrer.slice(0, 100) : '(direct)'
      });
    }
    /* El formulario de contacto de Shopify recarga la página con el éxito en Liquid. */
    if (CTX.lead_sent) {
      send('generate_lead', { form_name: CTX.lead_sent, method: 'form' });
    }
  }

  window.PSAnalytics = {
    track: send,
    whatsappClick: function (location, text) {
      send('whatsapp_click', { cta_location: location || 'body', cta_text: text || '', page_path: pagePath() });
      send('cta_click', { cta_location: location || 'body', cta_text: text || '', cta_type: 'whatsapp' });
    },
    contactClick: function (eventName, location, text) {
      send(eventName, { cta_location: location || 'body', cta_text: text || '', page_path: pagePath() });
      send('cta_click', { cta_location: location || 'body', cta_text: text || '', cta_type: eventName === 'phone_click' ? 'phone' : 'email' });
    },
    itemFromCartLine: function (line) {
      return {
        item_id: String(line.product_id || line.id || ''),
        item_name: line.product_title || line.title || '',
        item_category: line.product_type || CATEGORIA,
        item_variant: line.variant_title || '',
        price: (line.final_price || line.price || 0) / 100,
        quantity: line.quantity || 1
      };
    },
    addToCart: function (lines) {
      var items = lines.map(this.itemFromCartLine);
      if (!items.length) return;
      var value = items.reduce(function (s, i) { return s + i.price * i.quantity; }, 0);
      send('add_to_cart', { currency: CURRENCY, value: value, items: items });
    },
    removeFromCart: function (item) {
      if (!item) return;
      send('remove_from_cart', { currency: CURRENCY, value: item.price * item.quantity, items: [item] });
    },
    viewCart: function (cart) {
      if (!cart || !cart.items || !cart.items.length) return;
      send('view_cart', { currency: CURRENCY, value: (cart.total_price || 0) / 100, items: cart.items.map(this.itemFromCartLine) });
    },
    beginCheckout: function (items, value) {
      var cart = window.EducareCarrito && window.EducareCarrito.actual;
      if (!items && cart && cart.items) { items = cart.items.map(this.itemFromCartLine); value = (cart.total_price || 0) / 100; }
      if (!items && CTX.cart_items && CTX.cart_items.length) { items = CTX.cart_items; value = CTX.cart_value; }
      send('begin_checkout', { currency: CURRENCY, value: value || 0, items: items || [] });
    }
  };

  function start() { initPageEvents(); initScrollDepth(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
